<!--
 * @Author: fengzhongmei
 * @Date: 2020-04-26 10:13:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-31 17:13:48
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <Modal v-model="modal"
           :title="$t('关联用户')+'/'+$t('用户组')"
           width="600"
           :mask-closable="false"
           @on-cancel="cancel">
        <div class="associatedusers">
            <p class="name"><span>{{$t('权限标识')}}：</span>{{data.policyName}}</p>
            <p class="name"><span>{{$t('权限描述')}}：</span>{{$t(data.description)}}</p>
            <Tabs :animated="false"
                  @on-click='changeTab'
                  style="margin-top:20px;">
                <TabPane :label="$t('用户')"
                         name="user">
                    <div class="user">
                        <Transfer :data="userData"
                                  :titles="titles"
                                  :target-keys="currUserData"
                                  :list-style="listStyle"
                                  filterable
                                  :filter-method="filterMethod"
                                  @on-change="userHandleChange"></Transfer>
                    </div>
                </TabPane>
                <TabPane :label="$t('用户组')"
                         name="userGroup">
                    <div class="userGroup">
                        <Transfer :data="userGroupData"
                                  :titles="titles"
                                  :target-keys="currUserGroupData"
                                  :list-style="listStyle"
                                  filterable
                                  :filter-method="filterMethod"
                                  @on-change="userGroupHandleChange"></Transfer>
                    </div>
                </TabPane>
            </Tabs>
        </div>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'associatedusers',
    data () {
        return {
            modal: false,
            loading: false,
            data: {
                policySid: '',
                policyName: '',
                description: ''
            },
            tabValue: 'user',
            titles: [this.$t('未关联'), this.$t('已关联')],
            listStyle: {
                width: '250px',
                height: '300px'
            },
            currUserData: [],
            userData: [],
            currUserGroupData: [],
            userGroupData: []
        }
    },
    methods: {
        openModal (data) {
            this.modal = true
            this.tabValue = 'user'
            this.initUser()
            this.initUserGroup()
            // 编辑
            if (data) {
                this.data = data
                this.init()
            }
        },
        // 初始化数据
        init () {
            this.currUserData = []
            this.currUserGroupData = []
            this.axios.get(this.urlFormat(API.ACCESS_POLICES_ID, false, [this.data.policySid])).then(res => {
                this.loading = false
                // 用户组
                if (res.configUserGroups) {
                    for (let i = 0; i < res.configUserGroups.length; i++) {
                        this.currUserGroupData.push(res.configUserGroups[i].groupSid)
                    }
                }
                // 用户
                if (res.configUsers) {
                    for (let i = 0; i < res.configUsers.length; i++) {
                        this.currUserData.push(res.configUsers[i].userSid)
                    }
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 获取用户
        initUser () {
            this.userData = []
            this.axios.get(this.urlFormat(API.GET_ACCESS_SUBUSER, false), { params: { inProject: false } }).then(res => {
                this.loading = false
                for (let i = 0; i < res.length; i++) {
                    this.userData.push({
                        key: res[i].userSid,
                        label: this.$t(res[i].account),
                        description: this.$t(res[i].realName),
                        disabled: res[i].status !== '1' || res[i].originType === 'fromGroup'
                    })
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 获取用户组
        initUserGroup () {
            this.userGroupData = []
            this.axios.get(this.urlFormat(API.GET_USER_GROUP, false)).then(res => {
                this.loading = false
                for (let i = 0; i < res.length; i++) {
                    this.userGroupData.push({
                        key: res[i].groupSid,
                        label: this.$t(res[i].groupName),
                        description: res[i].description,
                        disabled: false
                    })
                }
            }).catch(e => {
                this.loading = false
            })
        },
        changeTab (name) {
            this.tabValue = name
        },
        filterMethod (data, query) {
            return data.label.indexOf(query) > -1
        },
        // 选中的用户
        userHandleChange (newTargetKeys) {
            this.currUserData = newTargetKeys
        },
        // 选中的用户组
        userGroupHandleChange (newTargetKeys) {
            this.currUserGroupData = newTargetKeys
        },
        // 提交
        submit () {
            const params = {
                policySid: this.data.policySid,
                userGroupIds: this.currUserGroupData,
                userIds: this.currUserData
            }
            this.loading = true
            this.axios.put(this.urlFormat(API.PUT_ACCESS_POLICES_RELATE, false), params).then(res => {
                this.loading = false
                this.$emit('refresh')
                this.cancel()
            }).catch(e => {
                this.loading = false
            })
        },
        // 清空数据
        cancel () {
            this.data = {
                policySid: '',
                policyName: '',
                description: ''
            }
            this.currUserData = []
            this.userData = []
            this.currUserGroupData = []
            this.userGroupData = []
            this.modal = false
        }
    }
}
</script>
<style lang="less" scoped>
.associatedusers {
    .name {
        margin: 15px 0 15px 0;
        span {
            display: inline-block;
            width: 100px;
            text-align: right;
        }
    }
}
</style>
